'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Checkbox = require('../../Checkbox/src/Checkbox.js');
var Dropdown = require('../../Dropdown/src/Dropdown.js');
var Filter_module = require('../styles/Filter.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Filter = ({ column }) => {
    const { options, enableColumnFilter } = column.columnDef;
    const columnFilterValue = column.getFilterValue();
    const sortedUniqueValues = React__namespace.useMemo(() => (enableColumnFilter ? Array.from(column.getFacetedUniqueValues().keys()).sort().slice(0, 5000) : []), [column, enableColumnFilter]);
    const cx = reactUtils.useStyles(Filter_module.default);
    const iconClassNames = cx('icon', {
        filtered: column.getIsFiltered(),
    });
    // dynamically generated select options from faceted values feature
    const innerOptions = React__namespace.useMemo(() => {
        if (options) {
            return options;
        }
        const uniqueOptions = [];
        uniqueOptions.push({
            label: 'Все',
            value: '',
            control: React__namespace.createElement(Checkbox.Checkbox, null),
        });
        sortedUniqueValues.forEach((value) => value &&
            uniqueOptions.push({
                label: value,
                value,
                control: React__namespace.createElement(Checkbox.Checkbox, null),
            }));
        return uniqueOptions;
    }, [options, sortedUniqueValues]);
    if (!enableColumnFilter && !options?.length) {
        return null;
    }
    const hanldeFilterChange = (newValue) => {
        if (newValue === '') {
            column.setFilterValue('');
            return;
        }
        const option = innerOptions.find((option) => option.value === newValue);
        option && column.setFilterValue(option.value);
    };
    return (React__namespace.createElement(Dropdown.Dropdown, { value: columnFilterValue, options: innerOptions, onChange: hanldeFilterChange, onClick: (e) => e.stopPropagation() },
        React__namespace.createElement("div", { className: cx('container'), onClick: (e) => e.stopPropagation() },
            React__namespace.createElement(reactIcons.TableFilter, { className: iconClassNames }))));
};

exports.Filter = Filter;
//# sourceMappingURL=Filter.js.map
